import { getPublicConfig } from "@/shared/config/config"
import type { HttpClient } from "@/shared/types/HttpClient"
import type { CreateNewPermissionRequest } from "../types/CreateNewPermissionRquest"

const { cmApiBaseUrl } = getPublicConfig()
const apiBaseUrl = `${cmApiBaseUrl}/spicedb`

export const createSpiceDbApi = (client: HttpClient) => ({
  createNewPermission: async (request: CreateNewPermissionRequest): Promise<boolean> =>
    client.post<boolean>(`${apiBaseUrl}/permissions`, request)
})
